import IconButton from '@mui/material/IconButton';
import { alpha, styled } from '@mui/material/styles';

/** Icon button with a rounded-square brand-tinted hover instead of the circular ripple. */
export const SquareIconButton = styled(IconButton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  '&:hover': {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
  },
}));
